import { createRoute, useParams } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const RoutineDetailPage = lazy(async () => {
  const m = await import("@/features/gym/components/routine-detail-page");
  return { default: m.RoutineDetailPage };
});

interface RoutineDetailSearch {
  /** Exercise picker open (`?picker=1`) or creating a custom one (`?picker=new`). */
  picker?: "1" | "new";
  /** Goals dialog open for a given routine_exercise (`?edit=<id>`). */
  edit?: string;
}

function RoutineDetailRoutePage() {
  const params = useParams({ from: "/_app/routines/$routineId" });
  return (
    <Suspense fallback={null}>
      <RoutineDetailPage routineId={() => params().routineId} />
    </Suspense>
  );
}

export const routineDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/routines/$routineId",
  validateSearch: (search: Record<string, unknown>): RoutineDetailSearch => {
    // CC-18: also accepts the NUMBER 1 (TanStack JSON-parses `?picker=1` to number 1).
    const picker =
      search.picker === "1" || search.picker === 1
        ? ("1" as const)
        : search.picker === "new"
          ? ("new" as const)
          : undefined;
    const edit =
      typeof search.edit === "string" && search.edit.trim() !== "" ? search.edit : undefined;
    // Omit empties for clean URLs that are idempotent on reload.
    return {
      ...(picker ? { picker } : {}),
      ...(edit ? { edit } : {}),
    };
  },
  component: RoutineDetailRoutePage,
});
